<template>
    <div class="">
        <Responsible />
        <Cooperation />
        <Academic />
        <Sport />
        <Concurs />
        <Course />
        <EventTeacher />
        <Event />
    </div>
</template>


<script>
    import Responsible from './cadet/responsible.vue';
    import Cooperation from './cadet/cooperation.vue';
    import Academic from './cadet/academic.vue';
    import Sport from './cadet/sport.vue';
    import Concurs from './cadet/concurs.vue';
    import Course from './cadet/course.vue';
    import EventTeacher from './cadet/eventteacher.vue';
    import Event from './cadet/event.vue';

    export default{

        components: {
            Responsible,
            Cooperation,
            Academic,
            Sport,
            Concurs,
            Course,
            EventTeacher,
            Event
        },


        data(){
            return {

            };
        },


        methods: {

        }

    }
</script>


<style>
    .info-desc{
        font-style: italic;
        margin-bottom: 40px;
    }
</style>